<p class="mat-title" *ngIf="props.label && props.hideLabel !== true">{{ props.label }}</p>
<p class="mat-body" *ngIf="props.description">{{ props.description }}</p>
